import { render, staticRenderFns } from "./ModelTree.vue?vue&type=template&id=3fbfdcd7&scoped=true"
import script from "./ModelTree.vue?vue&type=script&lang=js"
export * from "./ModelTree.vue?vue&type=script&lang=js"
import style0 from "./ModelTree.vue?vue&type=style&index=0&id=3fbfdcd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfdcd7",
  null
  
)

export default component.exports